import { Table } from "@/features/Table";
import { type A7OPCVMTimeSerieFile, getTimeSerieFilesColumns } from "./columns";
import {
  type FilterA7OPCVMTimeSerieFilesSchema,
  FilterA7OPCVMTimeSerieFiles,
} from "./filter";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_opcvm_time_serie_files";

export const A7OPCVMTimeSerieFilesTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(
    () => getTimeSerieFilesColumns(t),
    [t, i18n.language],
  );
  const columnVisibilityInit = {
    filename: false,
  };

  return (
    <Table<A7OPCVMTimeSerieFile, FilterA7OPCVMTimeSerieFilesSchema>
      label={t(`${table_name}.title`, { ns: "tables", defaultValue: "Files" })}
      table_name={table_name}
      columns={columns}
      columnVisibilityInit={columnVisibilityInit}
      filter={<FilterA7OPCVMTimeSerieFiles table_name={table_name} />}
      client="a7"
      disable_translations_request={true}
    />
  );
};
